import { BaseModel, convertToArrayModels, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toCroppedImage } from '~/shared/utils/image'
import { toDateFormatComma } from '~/shared/utils/date'
import DigitalLectureSpeaker from './DigitalLectureSpeaker'
import DigitalLectureVideoCard from './DigitalLectureVideoCard'

export default class DigitalLectureCourseDetail extends BaseModel {
  static override constructorName = 'DigitalLectureCourseDetail'

  id: number = 0
  name: string = ''
  slug: string = ''
  preview: string = ''
  'short_description': string = ''
  description: string = ''
  'date_publication': string = ''
  'likes_count': number = 0
  'views_count': number = 0
  'created_at': string = ''
  'updated_at': string = ''
  lectures: DigitalLectureVideoCard[] = []
  speakers: DigitalLectureSpeaker[] = []

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['lectures', 'speakers'])

      this.lectures = convertToArrayModels(data.lectures, DigitalLectureVideoCard)
      this.speakers = convertToArrayModels(data.speakers, DigitalLectureSpeaker)

      this.preview = toCroppedImage(this.preview)

      if (this.date_publication) {
        this.date_publication = toDateFormatComma(this.date_publication)
      }
    }
  }
}

registerModel(DigitalLectureCourseDetail)
